import React from 'react';

const PackageStonji: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_201_4151)">
        <rect width="80" height="80" fill="#00A868" />
        <path d="M80 0H0V80H80V0Z" fill="#00A868" />
        <path
          d="M70.0024 59.9999L39.9999 74.9986L10.0128 59.9999L10.0024 19.9999L39.9999 5.00122L70.0024 19.9999V59.9999Z"
          fill="#20252A"
        />
        <path
          d="M69.9665 20L66.4465 18.2245L36.4646 33.2232L39.9846 34.9987L69.9665 20Z"
          fill="#20252A"
        />
        <path
          d="M39.9843 34.9987L36.4333 33.2233L36.4488 73.2233L39.9843 74.9987V34.9987Z"
          fill="#20252A"
        />
        <path
          d="M10.0024 20L13.5224 18.2245L43.5044 33.2232L39.9844 34.9987L10.0024 20Z"
          fill="#20252A"
        />
        <path
          d="M39.9844 34.9987L43.5044 33.2233L43.5199 73.2387L39.9844 74.9987V34.9987Z"
          fill="#00A868"
        />
        <path
          d="M39.9844 38.5394V34.9987L69.9663 20V23.5355L39.9844 38.5394Z"
          fill="#00A868"
        />
        <path
          d="M39.9844 38.5394V34.9987L10.0024 20V23.5355L39.9844 38.5394Z"
          fill="#00A868"
        />
        <path
          d="M42.0698 19.8039L34.9988 16.2684L18.7717 24.3871L25.8427 27.9226L42.0698 19.8039Z"
          fill="white"
        />
        <path
          d="M25.8427 27.9226L18.7717 24.3871V44.8051L25.8427 48.351V27.9226Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_201_4151">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PackageStonji;
